<template>
  <v-row>
    <!-- kitchen sink -->
    <v-col cols="12">
      <app-card-code
        :title="`${$t('menu.configuration')} / ${$t('menu.agentes')}`"
      >
        <AgentesList></AgentesList>
      </app-card-code>
    </v-col>
  </v-row>
</template>

<script>
// eslint-disable-next-line import/no-unresolved
import AppCardCode from '@/@core/components/app-card-code/AppCardCode.vue'

// eslint-disable-next-line import/no-unresolved
import AgentesList from './tablas/AgentesList.vue'

export default {
  components: {
    AppCardCode,
    AgentesList,
  },
}
</script>
